<template>
  <span :class="['label', `label-production-panel-status-${status}`]">{{status | formatLookupName(ProductionPanelStageTaskStatusTypeLookup)}}</span>
</template>

<script>
import { ProductionPanelStageTaskStatusTypeLookup } from '@/store/types'

export default {
  name: 'LabelStageTaskStatusBadge',
  props: {
    status: String
  },
  created() {
    this.ProductionPanelStageTaskStatusTypeLookup = ProductionPanelStageTaskStatusTypeLookup
  },
}
</script>
